require([
	'jquery',
	'base/MbiMediaQuery',
	'project/Vendor/lib/greensock/TweenMax',
	'project/Vendor/lib/greensock/plugins/ScrollToPlugin',
	'project/Vendor/ScrollMagic',
	'project/Vendor/gsap',
	'project/Vendor/addIndicators'

], function($,
	mbiMq,
	tm,ScrollToPlugin,ScrollMagic,gsap
) {
	'use strict';
	// ----------------------------------------------------------------
	// IMAGE COVER FIX
	// ----------------------------------------------------------------

	if('desk+' in mbiMq.mqArea) {

		$('.js_scrollmagic:not(.js_scrollmagic_desk)').addClass('js_scrollmagic_desk');
	} else {
		$('.js_scrollmagic.js_scrollmagic_desk').removeClass('js_scrollmagic_desk');
	}


	var controller3 = new ScrollMagic.Controller({globalSceneOptions: {}});
	var initScroll = function() {
		$('.js_scrollmagic_desk:not(.finish)').each(function(){

			var $this = $(this);
			var height =$(this).outerHeight() + 20;
			var $element = $(this).find('.teaser__inner');

			var generalScene = new ScrollMagic.Scene({
					duration: height,
					triggerHook: 'onEnter',
					triggerElement: this
						}
					)
				.setClassToggle($element[0], 'fade')
				.addTo(controller3);

				if (!($('html').attr('data-browser-name') == 'safari' && $('html').attr('data-browser-version') == '11')) {
					generalScene.on("enter", function(e){
						//console.log(e);
						$this.addClass('finish');
					}) ;
				}

		});
	}
	if('desk+' in mbiMq.mqArea) {

		controller3.enabled(true);
		initScroll();
	}

	$(document).on('breakpoint', function() {
		if('desk+' in mbiMq.mqArea) {
			controller3 = new ScrollMagic.Controller({globalSceneOptions: {}});
			controller3.enabled(true);
			$('.js_scrollmagic:not(.js_scrollmagic_desk)').addClass('js_scrollmagic_desk');
			initScroll();
		} else {

			$('.js_scrollmagic.js_scrollmagic_desk').removeClass('js_scrollmagic_desk');
			setTimeout(function(){
				controller3.destroy();
				controller3.enabled(false);
			}, 500);


		}
	});

	var controllerFooter = new ScrollMagic.Controller({globalSceneOptions: {}});
	var initFooterScroll = function() {

		$('.js_footer').each(function(){

			var $this = $(this);
			var that = this
			var height =$(this).outerHeight() + 20;
			var $element = $('.sidebar');

			var generalScene = new ScrollMagic.Scene({
					offset: 350,
					triggerHook: 'onEnter',
					triggerElement: that
						}
					)
				.setClassToggle($element[0], 'footer-in-view')
				.addTo(controllerFooter); 				//console.log(e);


		});

	};
	controllerFooter.enabled(true);
	initFooterScroll();

});
define("root/Assets/Templates/Content/TeaserBlock/Js/TeaserBlock", function(){});

